import { render, staticRenderFns } from "./TranslateButton.vue?vue&type=template&id=8df7d14e"
import script from "./TranslateButton.vue?vue&type=script&lang=js"
export * from "./TranslateButton.vue?vue&type=script&lang=js"
import style0 from "./TranslateButton.vue?vue&type=style&index=0&id=8df7d14e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports